<label class="checkbox-label" [for]="id" [class.text-white]="style === 'white'"
    [class.checkbox-label-no-border]="style === 'white'">
    <input [id]="id" type="checkbox" [formControl]="control">
    <span class="checkmark"></span>
    {{title}}
    <i *ngIf="tooltip" class="pj-ico pj-ico-120 pj-ico-ayuda-info text-primary"
    data-toggle="popover" data-placement="top"
    [attr.data-trigger]="'hover'"
    data-html="true"
    [attr.data-content]="tooltip"
    tabindex="0"></i>
</label>